// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-bg.reasonsSliderContainer{margin-bottom:90px}.no-bg.reasonsSliderContainer:after{display:none}@media(max-width:767px){.no-bg.reasonsSliderContainer{margin-bottom:55px}}", ""]);
// Exports
module.exports = exports;
